import { action } from 'typesafe-actions';

import { ICheckesDataResponse } from 'ApiPackage/OpenDataModule/interfaces/ICheckesDataResponse';
import { IOpenDataResponse } from 'ApiPackage/OpenDataModule/interfaces/IOpenDataResponse';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

import { PublicOpenDataActionsEnum } from '../enums/PublicOpenDataActionsEnum';
import { IActiveTab } from '../interfaces/IActiveTab';

export const publicOpenDataGetData = (federalLaw: ISelectOption<string> & { value: boolean }) =>
  action(PublicOpenDataActionsEnum.PUBLIC_OPEN_DATA_GET_DATA, { federalLaw });
export const publicOpenDataSetData = (fetchedData: IOpenDataResponse) =>
  action(PublicOpenDataActionsEnum.PUBLIC_OPEN_DATA_SET_DATA, { fetchedData });
export const publicOpenDataSetActiveTab = (activeTab: IActiveTab) =>
  action(PublicOpenDataActionsEnum.PUBLIC_OPEN_DATA_SET_ACTIVE_TAB, { activeTab });
export const publicOpenDataGetChecksData = (year: number, month: number | string, isFederalLaw: boolean) =>
  action(PublicOpenDataActionsEnum.PUBLIC_OPEN_DATA_GET_CHECKS_DATA, { year, month, isFederalLaw });
export const publicOpenDataSetChecksData = (checksData: ICheckesDataResponse) =>
  action(PublicOpenDataActionsEnum.PUBLIC_OPEN_DATA_SET_CHECKS_DATA, { checksData });
